import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrudService<T> {
    
  constructor(protected http: HttpClient, protected baseUrl: string) {}

  listar(): Observable<T[]> {
    return this.http.get<T[]>(`${this.baseUrl}`);
  }

  buscarId(id: number): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${id}`);
  }

  crear(entity: T): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}`, entity);
  }

  actualizar(entity: T): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}`, entity);
  }

  eliminar(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}